function preventFormDoubleClick(form) {
    const formId = form.getAttribute('id');
    if (!formId) return; // Formulář musí mít ID

    form.addEventListener('submit', (event) => {
        const submitButtons = form.querySelectorAll('button[type="submit"], input[type="submit"]');
        submitButtons.forEach(button => {
            button.disabled = true;
            button.classList.add('disabled');
            // add loading
            const spinner = document.createElement('i');
            spinner.className = 'fas fa-spinner fa-spin ms-2';
            // add it to value text
            if (button.tagName === 'BUTTON') {
                button.appendChild(spinner);
            } else if (button.tagName === 'INPUT') {
               // New span needs to look same as button
                const span = document.createElement('span');
                span.className = button.className;
                span.innerText = button.value;
                span.appendChild(spinner);
                button.style.display = 'none';
                button.parentNode.insertBefore(span, button.nextSibling);

            }
        });
    });
}

// Inicializace
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('#frm-orderForm').forEach(form => {
        preventFormDoubleClick(form);
    });
});
